import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Http, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Ng2Highcharts } from 'ng2-highcharts';
import { ClipboardModule } from 'ngx-clipboard';
import { environment } from '../../environments/environment';
import { ApiService } from 'app/api.service';
import { EnvService } from 'app/env.service';
import { TrainingZonesService } from 'app/training-zones.service';
import { ChartsService } from 'app/charts.service';
import { LoaderService } from 'app/loader.service';
import { DurationPipe } from 'app/duration.pipe';
import { Angulartics2 } from 'angulartics2';

import { Observable } from 'rxjs/Observable'; // included for tests to run
import 'rxjs/add/operator/map'; // included for tests to run

declare var $: any;
declare var alertify: any;

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.scss'],
})
export class SessionComponent implements OnInit {
  private Parse: any = require('parse');

  @ViewChildren(Ng2Highcharts) allCharts;

  model: any = {};
  currentUser: any;
  polarChartMax: number;

  editingSessionTitle: boolean = false;

  modalOverlayVisible: boolean = false;
  powerZonesModalVisible: boolean = false;
  hrZonesModalVisible: boolean = false;

  mmpZones: any = [];
  mhrZones: any = [];
  ftpZones: any = [];
  thrZones: any = [];

  powerBandsVisible = false;
  hrBandsVisible = false;
  powerBands = [];
  hrBands = [];

  colors: any = ['#3f93f4', '#ed1c24', '#ffa505']; // Power, Heart Rate, Cadence

  lapsSummaryVisible: boolean = false;
  heading: any;
  fixedHeader: any;
  fixedHeaderOffset: any;
  fixedHeaderHeight: any;
  fixedHeaderWidth: any;
  masterChartOffset: any;

  masterChartOptions: any = {};
  polarChartOptions: any = {};
  revolutionChartOptions: any = {};
  timeInZoneChartOptions: any = {};
  legBalanceChartOptions: any = {};
  legBalanceOverTimeChartOptions: any = {};

  constructor(
    public http: Http,
    public apiService: ApiService,
    public envService: EnvService,
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private trainingZonesService: TrainingZonesService,
    private chartsService: ChartsService,
    private angulartics2: Angulartics2
  ) {
    if (this.Parse.User.current()) {
      this.currentUser = this.Parse.User.current();
    }

    // load training zones from services
    this.mmpZones = this.trainingZonesService.mmpZones();
    this.mhrZones = this.trainingZonesService.mhrZones();
    this.ftpZones = this.trainingZonesService.ftpZones();
    this.thrZones = this.trainingZonesService.thrZones();

    // load chart configs from services
    this.masterChartOptions = this.chartsService.masterChartOptions(this.colors, function() { return 'Time: <strong>' + DurationPipe.prototype.transform(this.x) + '</strong>'; });
    this.polarChartOptions = this.chartsService.polarChartOptions();
    this.revolutionChartOptions = this.chartsService.revolutionChartOptions();
    this.timeInZoneChartOptions = this.chartsService.timeInZoneChartOptions(this.colors, function() { return DurationPipe.prototype.transform(this.y); });
    this.legBalanceChartOptions = this.chartsService.legBalanceChartOptions();
    this.legBalanceOverTimeChartOptions = this.chartsService.legBalanceOverTimeChartOptions(function() { return `Time: <strong>` + DurationPipe.prototype.transform(this.x) + `</strong><br />Balance: <strong>` + this.points[0].y + `%/` + (100 - this.points[0].y) + `%</strong>`; });

    // Power
    window['Highcharts'].SVGRenderer.prototype.symbols.power = function(x, y, w, h) {
      return ['M', x + 8, y + 1.43, 'L', x + 16, y + 15, x, y + 15, x + 8, y + 1.43, 'z'];
    };

    // Heart Rate
    window['Highcharts'].SVGRenderer.prototype.symbols.heartRate = function(x, y, w, h) {
      return ['M', x + 1.2, y + 8.9, 'c-1.7-1.7-1.6-4.5,0.2-6.2s4.5-1.6,6.2,0.2C', x + 7.7, y + 3.1, x + 7.9, y + 3.3, x + 8, y + 3.5, 'c1.3-2,4-2.6,6-1.2c1.2,0.8,2,2.2,2,3.6c0,1.2-0.5,2.3-1.3,3.1l0,0C', x + 14.6, y + 9.1, x + 8, y + 15, x + 8, y + 15, 'L', x + 1.2, y + 8.9, 'z'];
    };

    // Cadence
    window['Highcharts'].SVGRenderer.prototype.symbols.cadence = function(x, y, w, h) {
      return ['M', x + 8, y, 'C', x + 3.6, y, x, y + 3.6, x, y + 8, 's3.6,8,8,8s8-3.6,8-8S', x + 12.4, y, x + 8, y, 'zM', x + 8, y + 12.3, 'c-2.4,0-4.3-1.9-4.3-4.3', 'S', x + 5.6, y + 3.7, x + 8, y + 3.7, 's4.3,1.9,4.3,4.3S', x + 10.4, y + 12.3, x + 8, y + 12.3, 'z'];
    };
  }

  ngOnInit() {
    this.loaderService.setLoading();

    let $this = this;
    let model;
    let allCharts;
    let polarChartOptions;
    let revolutionChartOptions;
    let timeInZoneChartOptions;
    let legBalanceChartOptions;
    let legBalanceOverTimeChartOptions;
    let headers = new Headers();
    let params = new URLSearchParams();

    $(window).on('resize', function() {
      $this.lapsSummaryVisible = false;

      $this.setPesChartHeight();

      setTimeout(function() {
        $this.setFixedHeaderDimensions();
      }, 100);
    });

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    params.append('include', 'sessionSummary,user.preferences,user.performanceState,userPerformanceState');

    let options = new RequestOptions({ headers: headers, params: params });

    return this.http.get(this.apiService.Parse.serverURL + '/classes/RideSession/' + this.route.snapshot.params.id, options)
      .map(response => response.json()).subscribe(
      response => {
        let $this = this;

        this.model = response;
        // console.log(response);

        if (this.model.state == 'ready') {
          // append WB device name to device object
          if (response.wattbikeDevice.serialNumber.startsWith("261")) {
            this.model.wattbikeDevice.title = 'Atom NG';
          } else if (response.wattbikeDevice.serialNumber.startsWith("26")) {
            this.model.wattbikeDevice.title = 'Atom';
          }else if (response.wattbikeDevice.serialNumber.startsWith("25")) {
            this.model.wattbikeDevice.title = 'Pro/Trainer';
          } else if (response.wattbikeDevice.serialNumber.startsWith("28")) {
            this.model.wattbikeDevice.title = '--';
          } else if (response.wattbikeDevice.serialNumber.startsWith("29")) {
            this.model.wattbikeDevice.title = 'Nucleus';
          } else if (response.wattbikeDevice.serialNumber.startsWith("30")) {
            this.model.wattbikeDevice.title = 'AtomX';
          } else {
            this.model.wattbikeDevice.title = '';
          }

          this.setPesChartHeight();

          setTimeout(function() {
            $this.setFixedHeaderDimensions();

            $(window).scroll(function() {
              if ($(this).scrollTop() >= $this.fixedHeaderOffset) {
                $this.fixedHeader.addClass('laps-summary-header--fixed');
                $this.heading.css({ marginBottom: $this.fixedHeaderHeight });

                if ($(this).scrollTop() >= ($this.masterChartOffset - $this.fixedHeaderHeight)) {
                  $this.fixedHeader.addClass('laps-summary-header--summary-hidden');
                }
              } else {
                $this.fixedHeader.removeClass('laps-summary-header--fixed');
                $this.fixedHeader.removeClass('laps-summary-header--summary-hidden');
                $this.heading.css({ marginBottom: 0 });
                $this.lapsSummaryVisible = false;
              }
            });
          }, 0);

          // Set the smoothing level to 0
          this.model.smoothingLevel = 0;

          // Create an empty array to map smoothed points to their original index
          this.model.smoothingMap = [];

          // Set the `max` value of the left Y axis on on the master chart
          this.masterChartOptions.yAxis[0].max = this.model.sessionSummary.powerMax;
          // this.masterChartOptions.yAxis[0].max = 650;

          let masterChartRightAxisMax;

          // Determine whether the HR or Cadence max value is highest
          if (this.model.sessionSummary.hrMax != null) {
            masterChartRightAxisMax = Math.max(this.model.sessionSummary.hrMax, this.model.sessionSummary.cadenceMax);
          } else {
            masterChartRightAxisMax = this.model.sessionSummary.cadenceMax;
          }

          // Set the `max` value of the right Y axis on the master chart
          this.masterChartOptions.yAxis[1].max = masterChartRightAxisMax;

          // Build an array of plotlines containing the marker for the first lap
          let masterChartPlotLines = [];
          let legBalanceOverTimePlotLines = [];

          // If the session has laps, then draw plotlines on the chart
          if (this.model.laps.length > 0) {
            // Loop through each lap and add it to the array
            this.model.laps.forEach(function(lap, index, array) {
              if (index == 0) {
                masterChartPlotLines.push({
                  color: '#999',
                  dashStyle: 'dot',
                  value: 0,
                  width: 1,
                  zIndex: 4,
                  label: {
                    // text: 'Lap 1 (0:00–' + DurationPipe.prototype.transform(lap) + ')'
                    style: {
                      color: '#999',
                      fontFamily: 'Apercu Mono Pro'
                    },
                    text: 'Lap 1'
                  }
                });
                legBalanceOverTimePlotLines.push({
                  color: '#555',
                  dashStyle: 'dot',
                  value: 0,
                  width: 1,
                  zIndex: 4,
                  label: {
                    // text: 'Lap 1 (0:00–' + DurationPipe.prototype.transform(lap) + ')'
                    style: {
                      color: '#555',
                      fontFamily: 'Apercu Mono Pro'
                    },
                    text: 'Lap 1'
                  }
                });
              }
              if (index !== array.length - 1) {
                masterChartPlotLines.push({
                  color: '#999',
                  dashStyle: 'dot',
                  value: lap,
                  width: 1,
                  zIndex: 4,
                  label: {
                    // text: 'Lap ' + (index + 2) + ' (' + DurationPipe.prototype.transform(lap) + '–' + DurationPipe.prototype.transform(array[index + 1]) + ')'
                    style: {
                      color: '#999',
                      fontFamily: 'Apercu Mono Pro'
                    },
                    text: 'Lap ' + (index + 2)
                  }
                });
                legBalanceOverTimePlotLines.push({
                  color: '#555',
                  dashStyle: 'dot',
                  value: lap,
                  width: 1,
                  zIndex: 4,
                  label: {
                    // text: 'Lap ' + (index + 2) + ' (' + DurationPipe.prototype.transform(lap) + '–' + DurationPipe.prototype.transform(array[index + 1]) + ')'
                    style: {
                      color: '#555',
                      fontFamily: 'Apercu Mono Pro'
                    },
                    text: 'Lap ' + (index + 2)
                  }
                });
              }
            });
          }

          // Draw the plotlines on the chart
          this.masterChartOptions.xAxis.plotLines = masterChartPlotLines;
          this.legBalanceOverTimeChartOptions.xAxis.plotLines = legBalanceOverTimePlotLines;

          if (this.model.user) {
            switch (this.model.user.preferences.workoutType) {
              case 'mmp':
              for (let i = 0; i < this.mmpZones.length; i++) {
                this.powerBands.push({
                  borderColor: 'rgba(63, 147, 244, .1)',
                  borderWidth: 1,
                  color: i & 1 ? null : 'rgba(63, 147, 244, .05)',
                  from: this.mmpZones[i].from * response.userPerformanceState.mmp,
                  label: {
                    text: this.mmpZones[i].text
                  },
                  to: this.mmpZones[i].to * response.userPerformanceState.mmp
                });
              };
              for (let i = 0; i < this.mhrZones.length; i++) {
                this.hrBands.push({
                  borderColor: 'rgba(237, 28, 36, .1)',
                  borderWidth: 1,
                  color: i & 1 ? null : 'rgba(237, 28, 36, .05)',
                  from: this.mhrZones[i].from * response.userPerformanceState.mhr,
                  label: {
                    text: this.mhrZones[i].text
                  },
                  to: this.mhrZones[i].to * response.userPerformanceState.mhr
                });
              }
              break;
              case 'ftp':
              for (let i = 0; i < this.ftpZones.length; i++) {
                this.powerBands.push({
                  borderColor: 'rgba(63, 147, 244, .1)',
                  borderWidth: 1,
                  color: i & 1 ? null : 'rgba(63, 147, 244, .05)',
                  from: this.ftpZones[i].from * response.userPerformanceState.ftp,
                  label: {
                    text: this.ftpZones[i].text
                  },
                  to: this.ftpZones[i].to * response.userPerformanceState.ftp
                });
              };
              for (let i = 0; i < this.thrZones.length; i++) {
                this.hrBands.push({
                  borderColor: 'rgba(237, 28, 36, .1)',
                  borderWidth: 1,
                  color: i & 1 ? null : 'rgba(237, 28, 36, .05)',
                  from: this.thrZones[i].from * response.userPerformanceState.thr,
                  label: {
                    text: this.thrZones[i].text
                  },
                  to: this.thrZones[i].to * response.userPerformanceState.thr
                });
              }
              break;
            }
          }

          // Update PES charts
          this.updatePesCharts(this.model.sessionSummary.pesLeftLegCoefficient, this.model.sessionSummary.pesRightLegCoefficient);

          let revolutionChartSeries = [];

          revolutionChartSeries.push({
            color: '#555',
            data: [{
              x: 0,
              y: 0
            }, {
              dataLabels: {
                enabled: true,
                format: '{x}°',
                style: {
                  'color': '#999',
                  'fontFamily': 'Apercu Mono Pro'
                }
              },
              x: Math.round(this.model.sessionSummary.anglePeakForceLeftAvg),
              y: $this.polarChartMax
            }],
            lineWidth: 1
          }, {
              color: '#555',
              data: [{
                x: 0,
                y: 0
              }, {
                dataLabels: {
                  enabled: true,
                  format: '{x}°',
                  style: {
                    'color': '#999',
                    'fontFamily': 'Apercu Mono Pro'
                  }
                },
                x: Math.round(this.model.sessionSummary.anglePeakForceRightAvg),
                y: $this.polarChartMax
              }],
              lineWidth: 1
            });

          this.revolutionChartOptions.series = revolutionChartSeries;

          // Retrieve the `.wbsr` file for this workout
          return this.http.get(this.apiService.Parse.serverURL + '/files/' + this.model.sessionData.wbsr.name, options)
            .map(response => response.json()).subscribe(
            response => {
              this.updateCharts(model, allCharts, polarChartOptions, revolutionChartOptions, response.revolutions, 0, timeInZoneChartOptions, legBalanceChartOptions, legBalanceOverTimeChartOptions);
            },
            error => alertify.error(error.message),
            () => { }
            );
        } else {
          this.loaderService.setLoaded();
        }
      },
      error => {
        switch (error.status) {
          case 404:
            this.router.navigateByUrl('/page-not-found', { skipLocationChange: true });
            break;
          default:
            this.router.navigateByUrl('/error', { skipLocationChange: true });
        }

        if (error.message) {
          alertify.error(error.message)
        }
      }
      );
  }

  focusContentEditable(element) {
    let range;
    let selection;

    range = document.createRange();
    range.selectNodeContents(element);
    range.collapse(false);
    selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  editSessionTitle() {
    if (this.currentUser) {
      let sessionTitle = document.getElementById('sessionTitle');

      if (this.editingSessionTitle == false) {
        this.editingSessionTitle = true;

        // Set the range and selection for the title element
        this.focusContentEditable(sessionTitle);

        // Focus the title element (doesn't work without the setTimeout)
        setTimeout(function() {
          sessionTitle.focus();
        }, 0);
      }

      // Re-apply matchHeight to ensure that content doesn't overflow the container if the height of the heading changes
      $(sessionTitle).on('input', function() {
        $.fn.matchHeight._apply($('.heading-matchheight'));
      });

      sessionTitle.addEventListener('keypress', function(event) {
        if (event.which === 13) {
          event.preventDefault();
        }
      });
    }
  }

  saveSessionTitle() {
    let headers = new Headers();
    let sessionTitle = document.getElementById('sessionTitle');

    this.editingSessionTitle = false;

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    let options = new RequestOptions({ headers: headers });

    return this.http.put(this.apiService.Parse.serverURL + '/classes/RideSession/' + this.route.snapshot.params.id, { title: $(sessionTitle).text() }, options)
      .map(response => response.json()).subscribe(
      response => {
        alertify.success('Session title saved successfully');
      },
      error => {
        alertify.error(error.message);
      });
  }

  cancelEditingSessionTitle() {
    this.editingSessionTitle = false;
  }

  shareLinkCopied() {
    alertify.success("Share link copied to clipboard");
  }

  lapChange(event) {
    this.loaderService.setLoading();

    let index = this.model.laps.indexOf(parseInt(event.target.value));
    let endTime = parseInt(event.target.value);
    let startTime;

    let model = this.model
    let polarChartMax;
    let allCharts = this.allCharts;
    let polarChartOptions;
    let revolutionChartOptions;
    let timeInZoneChartOptions;
    let legBalanceChartOptions;
    let legBalanceOverTimeChartOptions;
    let headers = new Headers();

    // Update PES charts
    this.updatePesCharts(this.model.sessionSummary.pesLeftLegCoefficient, this.model.sessionSummary.pesRightLegCoefficient);

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    let options = new RequestOptions({ headers: headers });

    if (index > 0) {
      startTime = parseInt(this.model.laps[index - 1]);
    } else {
      startTime = 0;
    }

    let body = {
      'objectId': this.route.snapshot.params.id,
      'startTime': startTime,
      'endTime': endTime
    }

    // Handle smoothing when changing laps
    let smoothingLevel = this.model.smoothingLevel;

    return this.http.post(this.apiService.Parse.serverURL + '/functions/getRideSessionSegment', body, options)
      .map(response => response.json()).subscribe(
      response => {
        let revolutionsCount = response.result.summary.revolutionsCount;

        // Set the session summary to the selected lap summary
        this.model.sessionSummary = response.result.summary;

        // Update the charts
        this.updateCharts(model, allCharts, polarChartOptions, revolutionChartOptions, response.result.revolutions, startTime, timeInZoneChartOptions, legBalanceChartOptions, legBalanceOverTimeChartOptions);

        // Re-apply smoothing if it's currently applied
        setTimeout(function() {
          if (smoothingLevel == 0) {
            $.each(allCharts._results[0].chart.series, function() {
              this.update({
                type: 'line',
                dataGrouping: {
                  enabled: false
                }
              });
            });
          } else {
            $.each(allCharts._results[0].chart.series, function() {
              this.update({
                type: 'spline',
                dataGrouping: {
                  enabled: true,
                  forced: true,
                  smoothed: true,
                  units: [[
                    'second', [smoothingLevel * (revolutionsCount / 100)]
                  ]]
                }
              });
            });
          };

          model.smoothingMap = allCharts._results[0].chart.series[3].groupMap;
        }, 0);

        this.angulartics2.eventTrack.next({ action: 'Lap Change', properties: { category: 'Session' } });
      });
  }

  setPesChartHeight() {
    if ($('.polar-chart').width() > 250) {
      $('.pes-chart').height(250 * .85);
    } else {
      $('.pes-chart').height($('.polar-chart').width() * .85);
    }
  }

  updateCharts(model, allCharts, polarChartOptions, revolutionChartOptions, revolutions, lapStartTime, timeInZoneChartOptions, legBalanceChartOptions, legBalanceOverTimeChartOptions) {
    let $this = this;
    let revolution = [];
    let polarChartMax = 0;
    let powerData = [];
    let heartrateData = [];
    let cadenceData = [];
    let polarChartSeries = [];
    let revolutionChartSeries = [];
    let mmpZones = this.mmpZones;
    let mhrZones = this.mhrZones;
    let ftpZones = this.ftpZones;
    let thrZones = this.thrZones;
    let leftLegBalanceOverTimeSeries = [];
    let rightLegBalanceOverTimeSeries = [];

    model = this.model;
    allCharts = this.allCharts;
    polarChartOptions = this.polarChartOptions;
    revolutionChartOptions = this.revolutionChartOptions;
    timeInZoneChartOptions = this.timeInZoneChartOptions;
    legBalanceChartOptions = this.legBalanceChartOptions;
    legBalanceOverTimeChartOptions = this.legBalanceOverTimeChartOptions;

    revolutions.forEach(function(revolution) {
      powerData.push({
        x: revolution.time,
        y: revolution.power,
        marker: {
          enabled: false
        }
      });
      heartrateData.push({
        x: revolution.time,
        y: revolution.heartrate,
        marker: {
          enabled: false
        }
      });
      cadenceData.push({
        x: revolution.time,
        y: revolution.cadence,
        marker: {
          enabled: false
        }
      });
    });

    let heartrateVisible = model.sessionSummary.hrAvg ? true : false;

    this.masterChartOptions.series = [{
      data: [{
        marker: {
          enabled: false
        }
      }],
      id: 'dummyPower',
      marker: {
        radius: 6,
        symbol: 'power'
      },
      name: 'W',
      pointStart: lapStartTime
    }, {
      data: [{
        marker: {
          enabled: false
        }
      }],
      id: 'dummyHeartRate',
      marker: {
        radius: 6,
        symbol: 'heartRate'
      },
      name: 'bpm',
      pointStart: lapStartTime,
      visible: heartrateVisible,
      yAxis: 1
    }, {
      data: [{
        marker: {
          enabled: false
        }
      }],
      id: 'dummyCadence',
      marker: {
        radius: 6,
        symbol: 'cadence'
      },
      name: 'rpm',
      pointStart: lapStartTime,
      yAxis: 1
    }, {
      data: powerData,
      id: 'power',
      linkedTo: 'dummyPower',
      marker: {
        enabled: false,
        radius: 6,
        symbol: 'power'
      },
      name: 'W'
    }, {
      data: heartrateData,
      id: 'heartRate',
      linkedTo: 'dummyHeartRate',
      marker: {
        enabled: false,
        radius: 6,
        symbol: 'heartRate'
      },
      name: 'bpm',
      yAxis: 1
    }, {
      data: cadenceData,
      id: 'cadence',
      linkedTo: 'dummyCadence',
      marker: {
        enabled: false,
        radius: 6,
        symbol: 'cadence'
      },
      name: 'rpm',
      yAxis: 1
    }];

    let legBalanceChartSeries = [{
      data: [{
        name: 'Right Leg',
        y: 100 - Math.round(model.sessionSummary.balanceAvg)
      }, {
        name: 'Left Leg',
        y: Math.round(model.sessionSummary.balanceAvg)
      }],
    }];

    legBalanceChartOptions.series = legBalanceChartSeries;

    let mmpTimeInZone = Array(mmpZones.length).fill(0);
    let hrTimeInZone = Array(mhrZones.length).fill(0);
    let ftpTimeInZone = Array(ftpZones.length).fill(0);
    let thrTimeInZone = Array(thrZones.length).fill(0);
    let anglePeakForceCombinedNewtons: any = [];

    $.each(revolutions, function(index) {
      let rev = this;

      if (rev.anglePeakForceLeftNewtons && rev.anglePeakForceRightNewtons) {
        anglePeakForceCombinedNewtons.push(rev.anglePeakForceLeftNewtons);
        anglePeakForceCombinedNewtons.push(rev.anglePeakForceRightNewtons);
      } else if (rev.polarForces) {
        // Calculate the peak force
        anglePeakForceCombinedNewtons.push(Math.max(...rev.polarForces.split(',')));
      }

      // Calculate time in zones for MMP/FTP
      if (model.user) {
        switch (model.user.preferences.workoutType) {
          case 'mmp':
          for (let i = 0; i < mmpZones.length; i++) {
            if (rev.power >= mmpZones[i].from * model.userPerformanceState.mmp && rev.power < mmpZones[i].to * model.userPerformanceState.mmp) {
              if (index == 0) {
                mmpTimeInZone[i] += (rev.time - lapStartTime);
              } else {
                mmpTimeInZone[i] += (rev.time - revolutions[index - 1].time);
              }
            }
          }
          for (let i = 0; i < mhrZones.length; i++) {
            if (rev.heartrate >= mhrZones[i].from * model.userPerformanceState.mhr && rev.heartrate < mhrZones[i].to * model.userPerformanceState.mhr) {
              if (index == 0) {
                hrTimeInZone[i] += (rev.time - lapStartTime);
              } else {
                hrTimeInZone[i] += (rev.time - revolutions[index - 1].time);
              }
            }
          }
          break;
          case 'ftp':
          for (let i = 0; i < ftpZones.length; i++) {
            if (rev.power >= ftpZones[i].from * model.userPerformanceState.ftp && rev.power < ftpZones[i].to * model.userPerformanceState.ftp) {
              if (index == 0) {
                ftpTimeInZone[i] += (rev.time - lapStartTime);
              } else {
                ftpTimeInZone[i] += (rev.time - revolutions[index - 1].time);
              }
            }
          }
          for (let i = 0; i < thrZones.length; i++) {
            if (rev.heartrate >= thrZones[i].from * model.userPerformanceState.thr && rev.heartrate < thrZones[i].to * model.userPerformanceState.thr) {
              if (index == 0) {
                thrTimeInZone[i] += (rev.time - lapStartTime);
              } else {
                thrTimeInZone[i] += (rev.time - revolutions[index - 1].time);
              }
            }
          }
          break;
        }
      }

      // Round the balance to calculate the left/right leg balance
      rev.balanceLeftLeg = Math.round(rev.balance);
      rev.balanceRightLeg = 100 - rev.balanceLeftLeg;

      if (index == revolutions.length - 1) {
        leftLegBalanceOverTimeSeries.push({
          dataLabels: {
            crop: false,
            enabled: true,
            format: '&plusmn;2%',
            style: {
              'color': '#555',
              'fontFamily': 'Apercu Mono Pro',
              'fontWeight': 'normal'
            },
            overflow: 'none',
            useHTML: true,
            x: 20,
            y: 78,
          },
          x: rev.time,
          y: rev.balanceLeftLeg
        });
      } else {
        leftLegBalanceOverTimeSeries.push({
          x: rev.time,
          y: rev.balanceLeftLeg
        });
      }

      rightLegBalanceOverTimeSeries.push({
        x: rev.time,
        y: rev.balanceRightLeg
      });

      if (rev.polarForces) {
        // Left leg calculations
        // Split the `polarForces` array
        rev.polarForcesLeftLeg = rev.polarForces.split(',').slice(0, rev.polarLeftCount).map(Number);

        // Right leg calculations
        // Split the `polarForces` array
        rev.polarForcesRightLeg = rev.polarForces.split(',').slice(rev.polarLeftCount).map(Number);

        let polarChartData = [];
        var pointInterval = 0;

        rev.polarForces.split(',').forEach(function(value, index) {
          if (index != 0) {
            if (index <= rev.polarLeftCount) {
              pointInterval += 180 / rev.polarLeftCount
            } else {
              pointInterval += 180 / rev.polarForcesRightLeg.length
            }
          }

          polarChartData.push({
            x: pointInterval,
            y: parseInt(value)
          });
        });

        polarChartSeries.push({
          color: 'rgba(85, 85, 85, .3)',
          data: polarChartData,
          lineWidth: .5,
          type: 'line'
        });
      }
    });

    // Round up the `anglePeakForceCombinedNewtons` value to the nearest 50 to get a sensible `max` for the polar chart
    let maxAnglePeakForce = Math.max.apply(null, anglePeakForceCombinedNewtons);

    polarChartMax = (Math.ceil(maxAnglePeakForce / 50) * 50) + 50;

    // Set the `max` value of the Y axis on the polar chart
    this.polarChartOptions.yAxis.max = polarChartMax;
    this.revolutionChartOptions.yAxis.max = polarChartMax;

    // Reset the polar chart to the lap summary data
    // Clear the existing state of the revolution chart
    revolutionChartSeries.push({
      color: '#555',
      data: [{
        x: 0,
        y: 0
      }, {
        dataLabels: {
          enabled: true,
          format: '{x}°',
          style: {
            'color': '#999',
            'fontFamily': 'Apercu Mono Pro'
          }
        },
        x: Math.round(this.model.sessionSummary.anglePeakForceLeftAvg),
        y: polarChartMax
      }],
      lineWidth: 1
    }, {
        color: '#555',
        data: [{
          x: 0,
          y: 0
        }, {
          dataLabels: {
            enabled: true,
            formatter: function() {
              return this.x - 180 + '°';
            },
            // format: '{x}°',
            style: {
              'color': '#999',
              'fontFamily': 'Apercu Mono Pro'
            }
          },
          x: Math.round(this.model.sessionSummary.anglePeakForceRightAvg),
          y: polarChartMax
        }],
        lineWidth: 1
      });

    this.revolutionChartOptions.series = revolutionChartSeries;

    this.masterChartOptions.plotOptions.series = {
      events: {
        legendItemClick: function(event) {
          this.chart.yAxis[1].update({
            title: {
              style: {
                visibility: 'visible'
              }
            }
          });
        },
        mouseOut: function(event) {
          $('.polar-chart__background').removeClass('polar-chart__background--faded');

          model.revolution = model.sessionSummary;

          // Clear the existing state of the revolution chart
          let revolutionChartSeries = [];

          revolutionChartSeries.push({
            color: '#555',
            data: [{
              x: 0,
              y: 0
            }, {
              dataLabels: {
                enabled: true,
                format: '{x}°',
                style: {
                  'color': '#999',
                  'fontFamily': 'Apercu Mono Pro'
                }
              },
              x: Math.round(model.sessionSummary.anglePeakForceLeftAvg),
              y: polarChartMax
            }],
            lineWidth: 1
          }, {
              color: '#555',
              data: [{
                x: 0,
                y: 0
              }, {
                dataLabels: {
                  enabled: true,
                  formatter: function() {
                    return this.x - 180 + '°';
                  },
                  style: {
                    'color': '#999',
                    'fontFamily': 'Apercu Mono Pro'
                  }
                },
                x: Math.round(model.sessionSummary.anglePeakForceRightAvg),
                y: polarChartMax
              }],
              lineWidth: 1
            });

          revolutionChartOptions.series = revolutionChartSeries;

          // Update PES charts
          $this.updatePesCharts(model.sessionSummary.pesLeftLegCoefficient, model.sessionSummary.pesRightLegCoefficient);
        }
      },
      point: {
        events: {
          mouseOver: function() {
            $('.polar-chart__background').addClass('polar-chart__background--faded');

            let rev = revolutions[model.smoothingLevel == 0 ? this.index : model.smoothingMap[this.index].start];

            // Round the balance to calculate the left/right leg balance
            rev.balanceLeftLeg = Math.round(revolutions[this.index].balance);
            rev.balanceRightLeg = 100 - rev.balanceLeftLeg

            if (rev.polarForces && !rev.anglePeakForceLeftNewtons && !rev.anglePeakForceRightNewtons) {
              // Left leg calculations
              // Split the `polarForces` array
              rev.polarForcesLeftLeg = rev.polarForces.split(',').slice(0, rev.polarLeftCount).map(Number);
              // Calculate the peak force
              rev.anglePeakForceLeftNewtons = Math.max(...rev.polarForcesLeftLeg);
              // Calculate the peak force angle by dividing the `polarForcesLeftLeg` value by 180°
              rev.anglePeakForceLeft = Math.round((180 / rev.polarLeftCount) * rev.polarForcesLeftLeg.indexOf(rev.anglePeakForceLeftNewtons));

              // Right leg calculations
              // Split the `polarForces` array
              rev.polarForcesRightLeg = rev.polarForces.split(',').slice(rev.polarLeftCount).map(Number);
              // Calculate the peak force
              rev.anglePeakForceRightNewtons = Math.max(...rev.polarForcesRightLeg);
              // Calculate the peak force angle by dividing the `polarForcesRightLeg` value by 180°
              rev.anglePeakForceRight = Math.round((180 / rev.polarForcesRightLeg.length) * rev.polarForcesRightLeg.indexOf(rev.anglePeakForceRightNewtons)) + 180;
            }

            let revData = [];
            var pointInterval = 0;

            if (rev.polarForces) {
              rev.polarForces.split(',').forEach(function(value, index) {
                if (index != 0) {
                  if (index <= rev.polarLeftCount) {
                    pointInterval += 180 / rev.polarLeftCount
                  } else {
                    pointInterval += 180 / rev.polarForcesRightLeg.length
                  }
                }

                revData.push({
                  x: pointInterval,
                  y: parseInt(value)
                });
              });
            }

            // Set the default colour to red
            let polarChartColor = '#ed1c24';

            if (rev.pesCombinedCoefficient) {
              // Round the `pesCombinedCoefficient`
              let pesCombinedCoefficient = Math.round(rev.pesCombinedCoefficient * 100);

              // Adjust the colour of the polar chart line based on the `pesCombinedCoefficient`
              if (pesCombinedCoefficient <= 59 || pesCombinedCoefficient >= 90) {
                polarChartColor = '#ed1c24';
              }
              if ((pesCombinedCoefficient >= 60 && pesCombinedCoefficient <= 69) || (pesCombinedCoefficient >= 89 && pesCombinedCoefficient <= 89)) {
                polarChartColor = '#e6b246';
              }
              if (pesCombinedCoefficient >= 70 && pesCombinedCoefficient <= 79) {
                polarChartColor = '#84c53e';
              }
            }

            revolutionChartSeries = [];

            revolutionChartSeries.push({
              color: polarChartColor,
              data: revData,
              type: 'line'
            }, {
                color: '#555',
                data: [{
                  x: 0,
                  y: 0
                }, {
                  dataLabels: {
                    enabled: true,
                    format: '{x}°',
                    style: {
                      'color': '#999',
                      'fontFamily': 'Apercu Mono Pro'
                    }
                  },
                  x: Math.round(rev.anglePeakForceLeft),
                  y: polarChartMax
                }],
                lineWidth: 1
              }, {
                color: '#555',
                data: [{
                  x: 0,
                  y: 0
                }, {
                  dataLabels: {
                    enabled: true,
                    format: Math.round(rev.anglePeakForceRight) - 180 + '°',
                    style: {
                      'color': '#999',
                      'fontFamily': 'Apercu Mono Pro'
                    }
                  },
                  x: Math.round(rev.anglePeakForceRight),
                  y: polarChartMax
                }],
                lineWidth: 1
              });

            revolutionChartOptions.series = revolutionChartSeries;

            // Update PES charts
            $this.updatePesCharts(rev.pesLeftLegCoefficient, rev.pesRightLegCoefficient);

            // Output the constructed `rev` object to the model
            model.revolution = rev;
          }
        }
      }
    }

    polarChartOptions.series = polarChartSeries;

    let timeInZoneCategories = [];
    let timeInZoneChartPowerSeries = [];
    let timeInZoneChartHrSeries = [];

    if (model.user) {
      switch (model.user.preferences.workoutType) {
        case 'mmp':
        for (let i = 0; i < mmpZones.length; i++) {
          timeInZoneCategories.push(mmpZones[i].text);
        }
        for (let i = 0; i < mmpTimeInZone.length; i++) {
          timeInZoneChartPowerSeries.push(mmpTimeInZone[i]);
        }
        for (let i = 0; i < hrTimeInZone.length; i++) {
          timeInZoneChartHrSeries.push(hrTimeInZone[i]);
        }
        break;
        case 'ftp':
        for (let i = 0; i < ftpZones.length; i++) {
          timeInZoneCategories.push(ftpZones[i].text);
        }
        for (let i = 0; i < ftpTimeInZone.length; i++) {
          timeInZoneChartPowerSeries.push(ftpTimeInZone[i]);
        }
        for (let i = 0; i < thrTimeInZone.length; i++) {
          timeInZoneChartHrSeries.push(thrTimeInZone[i]);
        }
        break;
      }
    }

    timeInZoneChartOptions.yAxis.max = model.sessionSummary.time;
    timeInZoneChartOptions.xAxis.categories = timeInZoneCategories;

    timeInZoneChartOptions.series = [{
      marker: {
        radius: 6,
        symbol: 'power'
      },
      name: 'Power',
      type: 'line'
    }, {
      color: this.colors[0],
      data: timeInZoneChartPowerSeries,
      linkedTo: ':previous',
      name: 'Power'
    }, {
      marker: {
        radius: 6,
        symbol: 'heartRate'
      },
      name: 'Heart Rate',
      type: 'line'
    }, {
      color: this.colors[1],
      data: timeInZoneChartHrSeries,
      linkedTo: ':previous',
      name: 'Heart Rate'
    }];

    legBalanceOverTimeChartOptions.series = [{
      name: 'Right Leg',
      data: rightLegBalanceOverTimeSeries,
      enableMouseTracking: false
    }, {
      name: 'Left Leg',
      data: leftLegBalanceOverTimeSeries
    }];

    this.loaderService.setLoaded();
  }

  updatePesCharts(pesLeftLegCoefficient, pesRightLegCoefficient) {
    // Set the `pesLeftLegCoefficient` value and pointer position
    if (document.getElementById('pesLeftLegCoefficient')) {
      if (!isNaN(pesLeftLegCoefficient)) {
        document.getElementById('pesLeftLegCoefficient').textContent = Math.round(pesLeftLegCoefficient * 100).toString();
        document.getElementById('pesLeftLegCoefficient').setAttribute('style', 'bottom:' + Math.round(pesLeftLegCoefficient * 100) + '%');
      }
    }

    // Set the `pesRightLegCoefficient` value and pointer position
    if (document.getElementById('pesRightLegCoefficient')) {
      if (!isNaN(pesLeftLegCoefficient)) {
        document.getElementById('pesRightLegCoefficient').textContent = Math.round(pesRightLegCoefficient * 100).toString();
        document.getElementById('pesRightLegCoefficient').setAttribute('style', 'bottom:' + Math.round(pesRightLegCoefficient * 100) + '%');
      }
    }
  }

  setFixedHeaderDimensions() {
    this.heading = $('.heading');
    this.fixedHeader = $('.laps-summary-header');
    this.fixedHeaderOffset = this.heading.offset().top + this.heading.outerHeight() + 1;
    this.fixedHeaderHeight = this.fixedHeader.height() + 1;
    this.fixedHeaderWidth = this.fixedHeader.width(this.fixedHeader.parents('.outer-container').width());
    if ($('.master-chart').length) {
      this.masterChartOffset = $('.master-chart').offset().top;
    }
  }

  toggleHeaderSummary() {
    if (this.lapsSummaryVisible === true) {
      this.lapsSummaryVisible = false;
      this.angulartics2.eventTrack.next({ action: 'Toggle Header Summary', properties: { category: 'Session', label: 'Off' } });
    } else {
      this.lapsSummaryVisible = true;
      this.angulartics2.eventTrack.next({ action: 'Toggle Header Summary', properties: { category: 'Session', label: 'On' } });
    }
  }

  smoothingRangeChanged() {
    let smoothingLevel = this.model.smoothingLevel;
    let revolutionsCount = this.model.sessionSummary.revolutionsCount;

    if (smoothingLevel == 0) {
      $.each(this.allCharts._results[0].chart.series, function() {
        this.update({
          type: 'line',
          dataGrouping: {
            enabled: false
          }
        });
      });
    } else {
      $.each(this.allCharts._results[0].chart.series, function() {
        this.update({
          type: 'spline',
          dataGrouping: {
            enabled: true,
            forced: true,
            smoothed: true,
            units: [[
              'second', [smoothingLevel * (revolutionsCount / 100)]
            ]]
          }
        });
      });

      this.model.smoothingMap = this.allCharts._results[0].chart.series[3].groupMap;
    }

    this.angulartics2.eventTrack.next({ action: 'Smoothing Changed', properties: { category: 'Session', label: 'Level ' + smoothingLevel } });
  }

  togglePowerBands() {
    if (this.powerBandsVisible === true) {
      this.hideHrBands();
      this.showPowerBands();
    } else {
      this.hidePowerBands();
    }
  }

  toggleHrBands() {
    if (this.hrBandsVisible === true) {
      this.hidePowerBands();
      this.showHrBands();
    } else {
      this.hideHrBands();
    }
  }

  showPowerBands() {
    this.hrBandsVisible = false;
    this.masterChartOptions.yAxis[0].plotBands = this.powerBands;
    this.masterChartOptions.yAxis[1].title.style = {
      visibility: 'hidden'
    };
    $.each(this.allCharts._results[0].chart.series, function() {
      if (this.options.id == 'dummyPower' || this.options.id == 'power') {
        this.update({
          visible: true
        });
      } else {
        this.update({
          visible: false
        });
      }
    });
    this.allCharts._results[0].chart.yAxis[0].update();
    this.allCharts._results[0].chart.yAxis[1].update();

    this.angulartics2.eventTrack.next({ action: 'Toggle Power Bands', properties: { category: 'Session', label: 'On' } });
  }

  hidePowerBands() {
    this.masterChartOptions.yAxis[0].plotBands = [];
    $.each(this.allCharts._results[0].chart.series, function() {
      this.update({
        visible: true
      })
    });
    $.each(this.allCharts._results[0].chart.yAxis, function() {
      this.update({
        title: {
          style: {
            visibility: 'visible'
          }
        }
      });
    });

    this.angulartics2.eventTrack.next({ action: 'Toggle Power Bands', properties: { category: 'Session', label: 'Off' } });
  }

  showPowerZonesDetails() {
    this.modalOverlayVisible = true;
    this.powerZonesModalVisible = true;

    this.angulartics2.eventTrack.next({ action: 'Show Power Zone Table', properties: { category: 'Session' } });
  }

  showHrBands() {
    this.powerBandsVisible = false;
    this.masterChartOptions.yAxis[1].plotBands = this.hrBands;
    this.masterChartOptions.yAxis[1].title.style = {
      visibility: 'visible'
    };
    $.each(this.allCharts._results[0].chart.series, function() {
      if (this.options.id == 'dummyHeartRate' || this.options.id == 'heartRate') {
        this.update({
          visible: true
        });
      } else {
        this.update({
          visible: false
        });
      }
    });
    this.allCharts._results[0].chart.yAxis[0].update();
    this.allCharts._results[0].chart.yAxis[1].update();

    this.angulartics2.eventTrack.next({ action: 'Toggle HR Bands', properties: { category: 'Session', label: 'On' } });
  }

  hideHrBands() {
    this.masterChartOptions.yAxis[1].plotBands = [];
    $.each(this.allCharts._results[0].chart.series, function() {
      this.update({
        visible: true
      });
    });
    $.each(this.allCharts._results[0].chart.yAxis, function() {
      this.update({
        title: {
          style: {
            visibility: 'visible'
          }
        }
      });
    });

    this.angulartics2.eventTrack.next({ action: 'Toggle HR Bands', properties: { category: 'Session', label: 'Off' } });
  }

  showHrZonesDetails() {
    this.modalOverlayVisible = true;
    this.hrZonesModalVisible = true;

    this.angulartics2.eventTrack.next({ action: 'Show HR Zone Table', properties: { category: 'Session' } });
  }

  closeModal() {
    this.modalOverlayVisible = false;
    this.powerZonesModalVisible = false;
    this.hrZonesModalVisible = false;
  }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/session/session.component.ts